"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanActionStatuses = exports.LoanActions = exports.EditSubmittedLoanActionMetadataSchema = exports.EditFundingRequestChangesetMetadataSchema = exports.EditFundingComponentChangesetMetadataSchema = exports.LoanTypes = exports.CalculatedLoanStatuses = exports.LoanStatuses = void 0;
const zod_1 = require("zod");
const UtilTypes = __importStar(require("./Utils"));
// ***********************************************
//                     LOAN
// ***********************************************
exports.LoanStatuses = [
    'pending',
    'canceled',
    'initiated',
    'funded',
    // *** Edit Post Results ***
    'pendingEdit',
    'overriddenFromEdit',
    'canceledEdit',
];
exports.CalculatedLoanStatuses = ['overdue', ...exports.LoanStatuses];
exports.LoanTypes = ['origination', 'extension', 'rollover'];
// ***********************************************
//                  LOAN ACTION
// ***********************************************
// ============================================================================
// EDIT FUNDING COMPONENT CHANGESET METADATA SCHEMA
// ============================================================================
exports.EditFundingComponentChangesetMetadataSchema = zod_1.z.object({
    originalFundingRequestComponentId: zod_1.z.string(),
    newFundingRequestComponentId: zod_1.z.string(),
    capitalProviderId: zod_1.z.string(),
    newLenderShareId: zod_1.z.string(),
    fundTransferDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct.nullable(),
    postingDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct.nullable(),
});
// ============================================================================
// EDIT FUNDING REQUEST CHANGESET METADATA SCHEMA
// ============================================================================
exports.EditFundingRequestChangesetMetadataSchema = zod_1.z.object({
    originalFundingRequestId: zod_1.z.string(),
    newFundingRequestId: zod_1.z.string(),
    effectiveDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct, // Utilize this date to help with ordering of changesets
    fundingRequestComponents: zod_1.z.array(exports.EditFundingComponentChangesetMetadataSchema),
});
// ============================================================================
// EDIT SUBMITTED LOAN ACTION METADATA SCHEMA
// ============================================================================
exports.EditSubmittedLoanActionMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal('editSubmitted'),
    fundingRequestChangesets: zod_1.z.array(exports.EditFundingRequestChangesetMetadataSchema),
});
exports.LoanActions = ['edit'];
exports.LoanActionStatuses = [
    'submitted',
    'approved',
    'executed',
    'canceled',
    'rejected',
];
//# sourceMappingURL=Loans.js.map